// extracted by mini-css-extract-plugin
export default {"block":"reassurance_block__f2AsU"};